<template>
  <div class="stocks-wrapper">
    <header class="page-header fade-in">
      <div>
        <h1>Stocks &amp; Articles</h1>
       
      </div>
      <div class="header-actions">
        <button class="btn btn-outline" @click="refresh" :disabled="loading">
          <i class="bi bi-arrow-clockwise"></i>
          <span>Actualiser</span>
        </button>
        
      </div>
    </header>

    <section class=" fade-in">
      <div class="toolbar">
        <div class="search">
          <i class="bi bi-search"></i>
          <input
            v-model.trim="searchTerm"
            type="search"
            placeholder="Rechercher par nom ou référence…"
          />
        </div>
        
      </div>
      <br>

      <div v-if="loading" class="state">
        <div class="loader"></div>
        <p>Chargement des articles…</p>
      </div>

      <div v-else-if="error" class="state error">
        <i class="bi bi-exclamation-triangle"></i>
        <p>{{ error }}</p>
        <button class="btn btn-primary" @click="refresh">Réessayer</button>
      </div>

      <div v-else-if="!filteredItems.length" class="state empty">
        <i class="bi bi-box"></i>
        <p>Aucun article trouvé.</p>
      </div>

      <div v-else class="items-grid">
        <article class="item-card" v-for="item in filteredItems" :key="item.id">
          <div class="item-header">
            <div v-if="item.image" class="item-image">
              <img
                :src="$imageUrl(item.image)"
                :alt="item.name"
                @error="handleImageError($event)"
              />
            </div>
            <div v-else class="item-image-placeholder">
              <i class="bi bi-image"></i>
            </div>
            <div class="item-header-content">
              <h3>{{ item.name }}</h3>
            </div>
          </div>
          <div class="item-body">

             <div class="stat" v-if="item.quantity > 0">
              <span>Quantité Chargé</span>
              <strong>{{ formatQuantity(item.quantity) }}</strong>
            </div>

            <div class="stat">
              <span>Stock disponible</span>
              <strong>{{ formatQuantity(item.stockQuantity) }}</strong>
            </div>
           
          </div>
          
        </article>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SellerItems",
  data() {
    return {
      loading: true,
      error: "",
      searchTerm: "",
    };
  },
  computed: {
    ...mapGetters("sellerSaleItem", {
      saleItems: "getAll",
    }),
    normalizedItems() {
      const source = Array.isArray(this.saleItems?.data)
        ? this.saleItems.data
        : Array.isArray(this.saleItems)
        ? this.saleItems
        : [];
      return source.map((entry) => {
        const reference = entry?.item_reference || entry?.reference || "—";
        const name =
          entry?.fullName || entry?.name || entry?.designation || reference;
        const stockQuantity =
          entry?.stockQuantity != null
            ? entry?.stockQuantity
            : entry?.stock_quantity != null
            ? entry?.stock_quantity
            : entry?.quantity != null
            ? entry?.quantity
            : entry?.qty != null
            ? entry?.qty
            : 0;
        const price =
          entry?.priceTTC != null
            ? entry?.priceTTC
            : entry?.price_ttc != null
            ? entry?.price_ttc
            : entry?.price != null
            ? entry?.price
            : 0;
        const totalPrice =
          entry?.totalPriceTTC != null
            ? entry?.totalPriceTTC
            : entry?.total_price_ttc != null
            ? entry?.total_price_ttc
            : null;
        const quantity =
          entry?.quantity != null
            ? entry?.quantity
            : entry?.qty != null
            ? entry?.qty
            : 0;
        return {
          id: entry?.id || entry?.uuid || reference,
          reference,
          name,
          stockQuantity: Number(stockQuantity) || 0,
          quantity: Number(quantity) || 0,
          price: Number(price) || 0,
          totalPrice: totalPrice != null ? Number(totalPrice) : null,
          image: entry?.image || null,
          sale_reference: entry?.sale_reference || null,
        };
      });
    },
    filteredItems() {
      if (!this.searchTerm) {
        return this.normalizedItems;
      }
      const term = this.searchTerm.toLowerCase();
      return this.normalizedItems.filter((item) =>
        [item.name, item.reference]
          .filter(Boolean)
          .map((value) => value.toString().toLowerCase())
          .some((value) => value.includes(term))
      );
    },
    totalItems() {
      return this.normalizedItems.length;
    },
    formattedTotalQuantity() {
      const total = this.normalizedItems.reduce(
        (sum, item) => sum + Number(item.stockQuantity || 0),
        0
      );
      return `Total stock : ${this.formatQuantity(total)}`;
    },
    imageFallback() {
      return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'%3E%3Crect width='120' height='120' fill='%23e2e8f0'/%3E%3Cg fill='%2394a3b8' font-family='sans-serif' font-size='12'%3E%3Ctext x='50%' y='50%' dominant-baseline='middle' text-anchor='middle'%3ENo Image%3C/text%3E%3C/g%3E%3C/svg%3E";
    },
  },
  methods: {
    async loadItems() {
      this.loading = true;
      this.error = "";
      try {
        await this.$store.dispatch("sellerSaleItem/getAll");
      } catch (error) {
        console.error("Error loading seller items", error);
        this.error = "Impossible de récupérer les articles.";
      } finally {
        this.loading = false;
      }
    },
    refresh() {
      this.loadItems();
    },
    goBack() {
      this.$router.back();
    },
    goToOrders(item) {
      this.$router.push({
        name: "orders-create",
        query: { item_reference: item.reference },
      });
    },
    formatCurrency(value) {
      const number = Number(value);
      if (Number.isNaN(number)) return value || "—";
      return number.toLocaleString("fr-FR", {
        style: "currency",
        currency: "MAD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatQuantity(value) {
      const number = Number(value);
      if (Number.isNaN(number)) return value || "—";
      return number % 1 === 0 ? number.toString() : number.toFixed(2);
    },
    formatDate(value) {
      if (!value) return "—";
      try {
        return new Date(value).toLocaleDateString();
      } catch (error) {
        return value;
      }
    },
    handleImageError(event) {
      if (event && event.target) {
        event.target.src = this.imageFallback;
      }
    },
  },
  mounted() {
    this.loadItems();
  },
};
</script>

<style scoped>
.stocks-wrapper {
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f8fb 0%, #f0f2f8 100%);
  padding: 2rem 2.5rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
  align-items: center;
}

.page-header h1 {
  margin: 0 0 0.35rem;
  font-size: 2.2rem;
  font-weight: 700;
  color: #0f172a;
}

.page-header p {
  margin: 0;
  color: #556073;
}

.header-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.page-body {
  background: #ffffff;
  border-radius: 24px;
  padding: 2rem;
  box-shadow: 0 24px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
}

.search {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.8rem 1.1rem;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  min-width: 280px;
  flex: 1;
}

.search input {
  border: none;
  background: transparent;
  outline: none;
  width: 100%;
  font-size: 1rem;
  color: #1f2937;
}

.stats {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #475569;
  font-weight: 600;
}

.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2.5rem 1rem;
  color: #6b7280;
  text-align: center;
}

.state.error {
  color: #b91c1c;
}

.state.empty {
  color: #64748b;
}

.state i {
  font-size: 2rem;
  color: #2563eb;
}

.loader {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 4px solid #d1d5db;
  border-top-color: #2563eb;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.items-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1rem;
}

.item-card {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), #ffffff 100%);
  border-radius: 16px;
  padding: 1rem;
  box-shadow: 0 18px 32px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.14);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 320px;
  overflow: hidden;
}

.item-header {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
}

.item-image {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  overflow: hidden;
  background: #f1f5f9;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.item-image-placeholder {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 1.5rem;
  flex-shrink: 0;
}

.item-header-content {
  flex: 1;
  min-width: 0;
}

.item-header-content h3 {
  margin: 0;
  font-size: 0.95rem;
  color: #0f172a;
  line-height: 1.3;
  word-break: break-word;
  font-weight: 600;
}

.item-header-content p {
  margin: 0.2rem 0 0;
  color: #64748b;
  font-size: 0.75rem;
}

.item-body {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.5rem;
}

.stat {
  background: rgba(99, 102, 241, 0.06);
  border-radius: 10px;
  padding: 0.6rem 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stat span {
  font-size: 0.7rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #6366f1;
  font-weight: 600;
}

.stat strong {
  font-size: 0.95rem;
  color: #0f172a;
  font-weight: 700;
}

.item-footer {
  margin-top: auto;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.85rem;
  border-radius: 10px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  font-size: 0.85rem;
}

.btn-compact {
  padding: 0.5rem 0.85rem;
  font-size: 0.85rem;
}

.btn-light {
  background: rgba(148, 163, 184, 0.15);
  color: #1f2937;
}

.btn-outline {
  border: 1px solid rgba(148, 163, 184, 0.6);
  background: white;
  color: #475569;
}

.btn-outline:hover {
  border-color: #4f46e5;
  color: #4f46e5;
}

.btn-primary {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: white;
  box-shadow: 0 10px 22px rgba(79, 70, 229, 0.25);
}

@media (max-width: 1024px) {
  .stocks-wrapper {
    padding: 1.5rem 1.5rem 4rem;
  }
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .header-actions {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 768px) {
  .stocks-wrapper {
    padding: 1.25rem 1rem 4rem;
  }
  .page-body {
    padding: 1.5rem;
  }
  .toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  .stats {
    justify-content: space-between;
  }
}

@media (max-width: 480px) {
  .page-header h1 {
    font-size: 1.8rem;
  }
  .page-body {
    padding: 1.25rem;
  }
  .items-grid {
    grid-template-columns: 1fr;
  }
}
</style>
